import { render, staticRenderFns } from "./accounting-statistics.vue?vue&type=template&id=f75bbbea&"
import script from "./accounting-statistics.vue?vue&type=script&lang=js&"
export * from "./accounting-statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports